import { render, staticRenderFns } from "./TodosOpenPaymentRequest.vue?vue&type=template&id=54cb0f8f"
import script from "./TodosOpenPaymentRequest.vue?vue&type=script&lang=js"
export * from "./TodosOpenPaymentRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports